import { render, staticRenderFns } from "./homeDataSummary.vue?vue&type=template&id=807bf8de&scoped=true&"
import script from "./homeDataSummary.vue?vue&type=script&lang=js&"
export * from "./homeDataSummary.vue?vue&type=script&lang=js&"
import style0 from "./homeDataSummary.vue?vue&type=style&index=0&id=807bf8de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807bf8de",
  null
  
)

export default component.exports